// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_JA4","right":"styles_right__2i2Sv"};